var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });

// src/fontFamily.ts
var fontFamilyPrimary = [
  "Lexend Deca",
  "Helvetica",
  "sans-serif"
].join(",");
var fontFamilyOs = [
  "Manrope",
  "Roboto",
  "sans-serif"
].join(",");

// src/themeOptions.ts
var components = {
  MuiCard: {
    styleOverrides: {
      root: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between"
      }
    }
  },
  MuiCardHeader: {
    styleOverrides: {
      content: {
        display: "flex",
        flexDirection: "column",
        overflow: "hidden"
      }
    }
  },
  MuiLink: {
    defaultProps: {
      underline: "none"
    },
    styleOverrides: {
      root: {
        "&:hover": {
          filter: "brightness(75%)"
        }
      }
    }
  },
  MuiTableCell: {
    styleOverrides: {
      body: {
        fontFamily: "monospace",
        whiteSpace: "nowrap"
      },
      head: {
        fontWeight: 700,
        whiteSpace: "nowrap"
      }
    }
  }
};
var typography = {
  body1: {
    lineHeight: 1.57
  },
  body2: {
    lineHeight: 1.57
  },
  button: {
    fontSize: "1rem",
    textTransform: "inherit"
  },
  fontFamily: fontFamilyPrimary,
  fontWeightBold: 700,
  fontWeightLight: 200,
  fontWeightMedium: 300,
  fontWeightRegular: 400,
  h1: {
    fontFamily: fontFamilyPrimary,
    fontSize: "4rem"
  },
  h2: {
    fontFamily: fontFamilyPrimary,
    fontSize: "2.4rem"
  },
  h3: {
    fontFamily: fontFamilyPrimary,
    fontSize: "2.24rem"
  },
  h4: {
    fontSize: "2rem"
  },
  h5: {
    fontSize: "1.5rem"
  },
  h6: {
    fontSize: "1.1rem"
  },
  subtitle1: {
    opacity: "70%"
  },
  subtitle2: {
    opacity: "70%"
  }
};
var themeOptions = {
  components,
  shape: {
    borderRadius: 8
  },
  spacing: 16,
  typography
};

// src/appThemeOptions.tsx
var partialAppThemeOptions = {
  components: {
    MuiTypography: {
      styleOverrides: {
        root: /* @__PURE__ */ __name(({ ownerState }) => {
          const { clamped } = ownerState;
          if (clamped) {
            const maxWidth = Number.parseInt(clamped, 10);
            return {
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              width: `clamp(1%, 100%, ${maxWidth}px)`
            };
          }
        }, "root")
      }
    }
  },
  spacing: 8
};
var appThemeOptions = {
  ...themeOptions,
  ...partialAppThemeOptions
};

// src/OsTheme/Components.tsx
var components2 = {
  MuiCard: {
    defaultProps: {
      elevation: 0
    },
    styleOverrides: {
      root: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between"
      }
    }
  },
  MuiCardHeader: {
    styleOverrides: {
      content: {
        display: "flex",
        flexDirection: "column",
        overflow: "hidden"
      }
    }
  },
  MuiLink: {
    defaultProps: {
      underline: "none"
    },
    styleOverrides: {
      root: {
        "&:hover": {
          filter: "brightness(75%)"
        }
      }
    }
  },
  MuiPaper: {
    defaultProps: {
      elevation: 0
    }
  },
  MuiTableCell: {
    styleOverrides: {
      body: {
        fontFamily: "monospace",
        whiteSpace: "nowrap"
      },
      head: {
        fontWeight: 700,
        whiteSpace: "nowrap"
      }
    }
  }
};

// src/OsTheme/Typography.tsx
var typography2 = {
  body1: {
    lineHeight: 1.57
  },
  body2: {
    lineHeight: 1.57
  },
  button: {
    fontSize: "1rem",
    textTransform: "inherit"
  },
  fontFamily: fontFamilyOs,
  fontWeightBold: 700,
  fontWeightLight: 300,
  fontWeightMedium: 600,
  fontWeightRegular: 500,
  h1: {
    fontSize: "4rem"
  },
  h2: {
    fontSize: "2.4rem"
  },
  h3: {
    fontSize: "2.24rem"
  },
  h4: {
    fontSize: "2rem"
  },
  h5: {
    fontSize: "1.5rem"
  },
  h6: {
    fontSize: "1.1rem"
  },
  subtitle1: {
    opacity: "70%"
  },
  subtitle2: {
    opacity: "70%"
  }
};

// src/OsTheme/DarkMode.tsx
var palette = {
  background: {
    default: "#141319",
    paper: "#1C1B20"
  },
  error: {
    main: "#ffb4ab"
  },
  mode: "dark",
  primary: {
    main: "#C9BFFA"
  },
  secondary: {
    main: "#C9C3DA"
  },
  text: {
    primary: "#100029",
    secondary: "#212023"
  }
};
var osThemeOptionsDarkMode = {
  components: components2,
  palette,
  shape: {
    borderRadius: 10
  },
  spacing: 16,
  typography: typography2
};

// src/OsTheme/LightMode.tsx
var palette2 = {
  background: {
    default: "#FFFFFF",
    paper: "#F6F4ED"
  },
  error: {
    main: "#BA1A1A"
  },
  mode: "light",
  primary: {
    main: "#100029"
  },
  secondary: {
    main: "#A060E0"
  },
  text: {
    primary: "#100029",
    secondary: "#212023"
  }
};
var osThemeOptionsLightMode = {
  components: components2,
  palette: palette2,
  shape: {
    borderRadius: 10
  },
  spacing: 16,
  typography: typography2
};

// src/OsTheme/osThemeOptions.tsx
var osThemeOptions = {
  ...osThemeOptionsDarkMode,
  ...osThemeOptionsLightMode
};

// src/partialDarkThemeOptions.tsx
import { darken } from "@mui/material";
var appComponents = {
  MuiPaper: {
    defaultProps: {
      variant: "elevation"
    }
  }
};
var partialDarkThemeOptions = {
  palette: {
    background: {
      default: darken("#171626", 0.1),
      paper: "#171626"
    },
    mode: "dark",
    primary: {
      main: "#9993F5"
    },
    secondary: {
      main: "#8EC8FF"
    }
  }
};
var partialAppDarkThemeOptions = {
  ...partialDarkThemeOptions,
  components: appComponents
};

// src/partialLightThemeOptions.tsx
var partialLightThemeOptions = {
  palette: {
    primary: {
      main: "#1f1a66"
    },
    secondary: {
      main: "#0f68c9"
    }
  }
};
var partialAppLightThemeOptions = {
  ...partialLightThemeOptions
};

// src/webThemeOptions.tsx
var partialWebThemeOptions = {};
var webThemeOptions = {
  ...themeOptions,
  ...partialWebThemeOptions
};
export {
  appThemeOptions,
  components,
  fontFamilyOs,
  fontFamilyPrimary,
  osThemeOptions,
  partialAppDarkThemeOptions,
  partialAppLightThemeOptions,
  partialDarkThemeOptions,
  partialLightThemeOptions,
  themeOptions,
  typography,
  webThemeOptions
};
//# sourceMappingURL=index.mjs.map